import React, { useCallback, useState } from 'react';

import WatchButton from './components/WatchButton/index';
import VideoOverlay from './components/VideoOverlay/index';

import { section, inner, box, videoPlayWrap } from './styles.module.scss';
import FormOverlay from './components/FormOverlay/index';

const Video = ({ data, lang, form, eventSlug }) => {
  const [showVideo, setShowVideo] = useState(null);

  const videoPlay = useCallback(() => {
    if (
      data?.webinarOnDemandFreeVideoAccess ||
      localStorage.getItem(eventSlug) !== null
    ) {
      setShowVideo(true);
    } else {
      setShowVideo(false);
    }
  }, [data?.webinarOnDemandFreeVideoAccess, eventSlug]);

  const setCloseOverlay = useCallback(() => {
    setShowVideo(null);
  }, []);

  const allowVideoOnSubmit = useCallback(() => {
    typeof window !== 'undefined' && localStorage.setItem(eventSlug, true);

    setTimeout(() => {
      setShowVideo(true);
    }, 100);
  }, []);

  return (
    <section className={section}>
      <div className="scr-wrap">
        <div className={inner}>
          <div className={box}>
            <img
              src={data?.webinarOnDemandVideoPoster?.sourceUrl}
              alt="Video poster"
            />

            <div className={videoPlayWrap}>
              <WatchButton
                handleClick={videoPlay}
                data={data?.webinarOnDemandVideoButtonTitle}
              />
            </div>

            {showVideo === true && (
              <VideoOverlay data={data} closeOverlay={setCloseOverlay} />
            )}

            {showVideo === false && (
              <FormOverlay
                data={form}
                closeOverlay={setCloseOverlay}
                lang={lang}
                allowVideo={allowVideoOnSubmit}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Video;
